export default [
  { id: 1, name: "Afghanistan" },
  { id: 2, name: "Albania" },
  { id: 3, name: "Algeria" },
  { id: 4, name: "American Samoa" },
  { id: 5, name: "Andorra" },
  { id: 6, name: "Angola" },
  { id: 7, name: "Anguilla" },
  { id: 8, name: "Antarctica" },
  { id: 9, name: "Antigua and Barbuda" },
  { id: 10, name: "Argentina" },
  { id: 11, name: "Armenia" },
  { id: 12, name: "Aruba" },
  { id: 13, name: "Australia" },
  { id: 14, name: "Austria" },
  { id: 15, name: "Azerbaijan" },
  { id: 16, name: "Bahamas" },
  { id: 17, name: "Bahrain" },
  { id: 18, name: "Bangladesh" },
  { id: 19, name: "Barbados" },
  { id: 20, name: "Belarus" },
  { id: 21, name: "Belgium" },
  { id: 22, name: "Belize" },
  { id: 23, name: "Benin" },
  { id: 24, name: "Bermuda" },
  { id: 25, name: "Bhutan" },
  { id: 26, name: "Bolivia" },
  { id: 27, name: "Bosnia and Herzegovina" },
  { id: 28, name: "Botswana" },
  { id: 29, name: "Bougainville" },
  { id: 30, name: "Brazil" },
  { id: 31, name: "British Indian Ocean Territory" },
  { id: 32, name: "Brunei" },
  { id: 33, name: "Bulgaria" },
  { id: 34, name: "Burkina Faso" },
  { id: 35, name: "Burundi" },
  { id: 36, name: "Cambodia" },
  { id: 37, name: "Cameroon" },
  { id: 38, name: "Canada" },
  { id: 39, name: "Cape Verde" },
  { id: 40, name: "Cayman Islands" },
  { id: 41, name: "Central African Republic" },
  { id: 42, name: "Chad" },
  { id: 43, name: "Chile" },
  { id: 44, name: "China" },
  { id: 45, name: "Christmas Island" },
  { id: 46, name: "Cocos Islands" },
  { id: 47, name: "Colombia" },
  { id: 48, name: "Comoros" },
  { id: 49, name: "Cook Islands" },
  { id: 50, name: "Costa Rica" },
  { id: 51, name: "Croatia" },
  { id: 52, name: "Cuba" },
  { id: 53, name: "Cyprus" },
  { id: 54, name: "Czech Republic" },
  { id: 55, name: "Denmark" },
  { id: 56, name: "Djibouti" },
  { id: 57, name: "Dominica" },
  { id: 58, name: "Dominican Republic" },
  { id: 59, name: "Ecuador" },
  { id: 60, name: "Egypt" },
  { id: 61, name: "El Salvador" },
  { id: 62, name: "Equatorial Guinea" },
  { id: 63, name: "Eritrea" },
  { id: 64, name: "Estonia" },
  { id: 65, name: "Eswatini" },
  { id: 66, name: "Ethiopia" },
  { id: 67, name: "Fiji" },
  { id: 68, name: "Finland" },
  { id: 69, name: "France" },
  { id: 70, name: "French Guiana" },
  { id: 71, name: "French Polynesia" },
  { id: 72, name: "Gabon" },
  { id: 73, name: "Gambia" },
  { id: 74, name: "Georgia" },
  { id: 75, name: "Germany" },
  { id: 76, name: "Ghana" },
  { id: 77, name: "Gibraltar" },
  { id: 78, name: "Greece" },
  { id: 79, name: "Greenland" },
  { id: 80, name: "Grenada" },
  { id: 81, name: "Guadeloupe" },
  { id: 82, name: "Guam" },
  { id: 83, name: "Guatemala" },
  { id: 84, name: "Guernsey" },
  { id: 85, name: "Guinea" },
  { id: 86, name: "Guinea-Bissau" },
  { id: 87, name: "Guyana" },
  { id: 88, name: "Haiti" },
  { id: 89, name: "Honduras" },
  { id: 90, name: "Hong Kong" },
  { id: 91, name: "Hungary" },
  { id: 92, name: "Iceland" },
  { id: 93, name: "India" },
  { id: 94, name: "Indonesia" },
  { id: 95, name: "Iran" },
  { id: 96, name: "Iraq" },
  { id: 97, name: "Ireland" },
  { id: 98, name: "Isle of Man" },
  { id: 99, name: "Israel" },
  { id: 100, name: "Italy" },
  { id: 101, name: "Ivory Coast" },
  { id: 102, name: "Jamaica" },
  { id: 103, name: "Japan" },
  { id: 104, name: "Jersey" },
  { id: 105, name: "Jordan" },
  { id: 106, name: "Kazakhstan" },
  { id: 107, name: "Kenya" },
  { id: 108, name: "Kiribati" },
  { id: 109, name: "Kuwait" },
  { id: 110, name: "Kyrgyzstan" },
  { id: 111, name: "Laos" },
  { id: 112, name: "Latvia" },
  { id: 113, name: "Lebanon" },
  { id: 114, name: "Lesotho" },
  { id: 115, name: "Liberia" },
  { id: 116, name: "Libya" },
  { id: 117, name: "Liechtenstein" },
  { id: 118, name: "Lithuania" },
  { id: 119, name: "Luxembourg" },
  { id: 120, name: "Macau" },
  { id: 121, name: "Madagascar" },
  { id: 122, name: "Malawi" },
  { id: 123, name: "Malaysia" },
  { id: 124, name: "Maldives" },
  { id: 125, name: "Mali" },
  { id: 126, name: "Malta" },
  { id: 127, name: "Marshall Islands" },
  { id: 128, name: "Martinique" },
  { id: 129, name: "Mauritania" },
  { id: 130, name: "Mauritius" },
  { id: 131, name: "Mayotte" },
  { id: 132, name: "Mexico" },
  { id: 133, name: "Micronesia" },
  { id: 134, name: "Moldova" },
  { id: 135, name: "Monaco" },
  { id: 136, name: "Mongolia" },
  { id: 137, name: "Montenegro" },
  { id: 138, name: "Montserrat" },
  { id: 139, name: "Morocco" },
  { id: 140, name: "Mozambique" },
  { id: 141, name: "Myanmar" },
  { id: 142, name: "Namibia" },
  { id: 143, name: "Nauru" },
  { id: 144, name: "Nepal" },
  { id: 145, name: "Netherlands" },
  { id: 146, name: "New Caledonia" },
  { id: 147, name: "New Zealand" },
  { id: 148, name: "Nicaragua" },
  { id: 149, name: "Niger" },
  { id: 150, name: "Nigeria" },
  { id: 151, name: "Niue" },
  { id: 152, name: "North Korea" },
  { id: 153, name: "North Macedonia" },
  { id: 154, name: "Northern Mariana Islands" },
  { id: 155, name: "Norway" },
  { id: 156, name: "Oman" },
  { id: 157, name: "Pakistan" },
  { id: 158, name: "Palau" },
  { id: 159, name: "Palestine" },
  { id: 160, name: "Panama" },
  { id: 161, name: "Papua New Guinea" },
  { id: 162, name: "Paraguay" },
  { id: 163, name: "Peru" },
  { id: 164, name: "Philippines" },
  { id: 165, name: "Poland" },
  { id: 166, name: "Portugal" },
  { id: 167, name: "Puerto Rico" },
  { id: 168, name: "Qatar" },
  { id: 169, name: "Réunion" },
  { id: 170, name: "Romania" },
  { id: 171, name: "Russia" },
  { id: 172, name: "Rwanda" },
  { id: 173, name: "Saint Barthelemy" },
  { id: 174, name: "Saint Helena" },
  { id: 175, name: "Saint Kitts and Nevis" },
  { id: 176, name: "Saint Lucia" },
  { id: 177, name: "Saint Martin" },
  { id: 178, name: "Saint Pierre and Miquelon" },
  { id: 179, name: "Saint Vincent and the Grenadines" },
  { id: 180, name: "Samoa" },
  { id: 181, name: "San Marino" },
  { id: 182, name: "Sao Tome and Principe" },
  { id: 183, name: "Saudi Arabia" },
  { id: 184, name: "Senegal" },
  { id: 185, name: "Serbia" },
  { id: 186, name: "Seychelles" },
  { id: 187, name: "Sierra Leone" },
  { id: 188, name: "Singapore" },
  { id: 189, name: "Sint Maarten" },
  { id: 190, name: "Slovakia" },
  { id: 191, name: "Slovenia" },
  { id: 192, name: "Solomon Islands" },
  { id: 193, name: "Somalia" },
  { id: 194, name: "South Africa" },
  { id: 195, name: "South Korea" },
  { id: 196, name: "South Sudan" },
  { id: 197, name: "Spain" },
  { id: 198, name: "Sri Lanka" },
  { id: 199, name: "Sudan" },
  { id: 200, name: "Suriname" },
  { id: 201, name: "Sweden" },
  { id: 202, name: "Switzerland" },
  { id: 203, name: "Syria" },
  { id: 204, name: "Taiwan" },
  { id: 205, name: "Tajikistan" },
  { id: 206, name: "Tanzania" },
  { id: 207, name: "Thailand" },
  { id: 208, name: "Timor-Leste" },
  { id: 209, name: "Togo" },
  { id: 210, name: "Tokelau" },
  { id: 211, name: "Tonga" },
  { id: 212, name: "Trinidad and Tobago" },
  { id: 213, name: "Tunisia" },
  { id: 214, name: "Turkey" },
  { id: 215, name: "Turkmenistan" },
  { id: 216, name: "Turks and Caicos Islands" },
  { id: 217, name: "Tuvalu" },
  { id: 218, name: "Uganda" },
  { id: 219, name: "Ukraine" },
  { id: 220, name: "United Arab Emirates" },
  { id: 221, name: "United Kingdom" },
  { id: 222, name: "United States" },
  { id: 223, name: "Uruguay" },
  { id: 224, name: "Uzbekistan" },
  { id: 225, name: "Vanuatu" },
  { id: 226, name: "Vatican City" },
  { id: 227, name: "Venezuela" },
  { id: 228, name: "Vietnam" },
  { id: 229, name: "Wallis and Futuna" },
  { id: 230, name: "Western Sahara" },
  { id: 231, name: "Yemen" },
  { id: 232, name: "Zambia" },
  { id: 233, name: "Zimbabwe" }
]
